import React, { useCallback, useContext, useMemo } from 'react'
import { ReturingCustomersLayoutContext } from '../ReturningCustomersLayout';
import { MainTracker } from '../../../../PixelTrackers/MainTracker';
import ProductAvailabilityTag from './ProductAvailabilityTag';
import * as translator from "../../../../utils/translator";
import { useCartContext } from '../../../../customHooks/useCart';

const COUNTRIES_ALLOWING_PO_DESIGN = ['FR', 'CH'];

interface QuantityOptionProps {
    quantity: number,
    productItemID: number,
    inStock: boolean,
    price: number,
    isColLayout: boolean,
    customQuantity?: string,
    sparedCost: number,
    disabled?: boolean,
    isResponsiveLayout?: boolean
}
const QuantityOption: React.FC<QuantityOptionProps> = ({ quantity, productItemID, inStock, disabled, price, isColLayout, customQuantity, isResponsiveLayout, sparedCost }) => {

    const context = useContext(ReturingCustomersLayoutContext);
    const { cartCurrency } = useCartContext();

    const isSelected = context?.selectedProductItemID === productItemID && !disabled;
    const selectedProduct = context?.selectedProduct;
    const productItemToPlan = context?.productItemToPlan;
    const useCustomQuantity = selectedProduct?.use_custom_quantity || context?.countryID.toUpperCase() === "FR";
    const spareTranslation = translator.translate(
        context?.languageID,
        "default",
        "ChooseTreatment/spare"
    )

    const quantityType = customQuantity?.slice(customQuantity?.indexOf(" ") + 1)

    const onSelect = useCallback(() => {
        if (context?.selectedProductItemID !== productItemID) {
            context?.setSelectedProductItemID(productItemID);
            const productItem = selectedProduct?.items.find((item) => item.product_item_id === productItemID);
            context?.setIsExpressProductItem(productItem?.express_stock || false);
            context?.setSelectedSubscriptionPlanID(null);
            MainTracker.superProperties({
                "Product Quantity": quantity,
            });
            window.eventsTracking.track({ e: "Click change Product Quantity" });

            if (productItemToPlan) {
                const plans = productItemToPlan[productItemID]
                if (plans) {
                    context?.setSelectedSubscriptionPlanID(plans[0]);
                } else {
                    context?.setSelectedSubscriptionPlanID(null);
                }
            }
        }

    }, [context, productItemID, productItemToPlan]);

    const style = useMemo(() => {
        let css = 'max-h-[120px] p-10 relative rounded-md flex items-center justify-center';
        if (!disabled) {
            css += ' cursor-pointer';
        } else {
            css += ' cursor-not-allowed bg-[#f0eded]';
        }

        if (isSelected) {
            css += ' bg-[#F7FAEF] text-[#0d2c54]';
        } else {
            css += ' text-[#808080]';
        }

        if (isColLayout) {
            css += ' flex-row justify-between items-center h-[60px] p-5';
        } else {
            css += ' flex-col items-center justify-center';
        }

        return css
    }, [inStock, isSelected, isColLayout])

    return (
        <div>
            <div id={"product_item_" + productItemID.toString() + (isResponsiveLayout ? "_responsive" : "")} style={
                {
                    border: isSelected ? "1px solid #269C6E" : "1px solid #e0e0e0",
                }
            } onClick={!disabled ? onSelect : () => { }} className={style}>
                {isSelected && <span className="absolute top-[-10px] right-[-10px] w-[25px] h-[25px] bg-primary-lightgreen rounded-full flex items-center justify-center text-white text-lg">✓</span>}

                {useCustomQuantity || isColLayout ? <>
                    <p className='font-medium text-md'>{customQuantity}</p>
                </> :
                    <div className={isColLayout ? 'flex flex-row gap-2 items-end' : ''}>
                        <div className={`flex flex-col items-center justify-center ${quantityType && quantityType.length > 3 ? 'gap-0' : ''}`}>
                            <p className={`font-medium text-lg ${quantityType && quantityType.length > 3 ? 'text-center w-full' : ''}`}>{quantity}</p>
                            {quantityType && (
                                <p className={`${isColLayout ? 'text-md' : 'text-xs'} flex justify-center ${quantityType.length > 3 ? 'w-full text-center' : ''}`}>
                                    {quantityType}
                                </p>
                            )}
                        </div>
                    </div>
                }

                <div id='availability-tag-and-price' className='flex  items-center gap-2'>
                    {
                        context?.hidePrices || (COUNTRIES_ALLOWING_PO_DESIGN.includes(context?.countryID?.toUpperCase() || '') && !inStock && !selectedProduct?.is_pre_orderable) ?  null : <p className={`${isColLayout ? 'text-md' : 'text-xs'} flex text-nowrap items-center font-medium `}>{translator.getPrice(price, context?.localeID, cartCurrency.rate)}</p>
                    }

                    {
                        COUNTRIES_ALLOWING_PO_DESIGN.includes(context?.countryID?.toUpperCase() || '') ? <ProductAvailabilityTag inStock={inStock} /> : null
                    }
                </div>

            </div>
            {sparedCost <= 0 || (context?.hidePrices || (COUNTRIES_ALLOWING_PO_DESIGN.includes(context?.countryID?.toUpperCase() || '') && !inStock && !selectedProduct?.is_pre_orderable)) ? null : <p id='saved-price' className='text-xs mt-1 flex items-center justify-center text-[#656d79]'>{spareTranslation} { translator.getPrice(sparedCost, context?.localeID, cartCurrency.rate)}</p>}
        </div>
    )
}

export default QuantityOption
